import type {
  BackgroundController,
  ThemeDefinition,
} from '../../core/presentation-registry';
import YAML from 'yaml';
import './theme.css';
import manifestSource from './theme.yaml?raw';
import welcomeFlightFactory from './animations/welcome-flight.js';
import malfunctionFactory from './animations/malfunctions.js';
import {createSlideMarkBackgroundPlayer} from './backgrounds/player';
import type {SlideMarkDaySkyBackground} from './backgrounds/types';

const STAGES: Record<string, number> = {
  dawn: 0,
  morning: 1,
  'early-morning': 2,
  'late-morning': 3,
  midday: 4,
  afternoon: 5,
  'golden-hour': 6,
  'blue-hour': 7,
  sunset: 8,
};

function daySkyBackground(id: string): SlideMarkDaySkyBackground {
  const name = id.split(':').at(-1) ?? 'midday';
  return {
    id,
    title: name,
    kind: 'day-sky',
    animation: 'skydive:day',
    source: 'original:createDaySky',
    stage: STAGES[name] ?? STAGES.midday,
    transition: 'cut',
  };
}

function createBackground(): BackgroundController {
  const player = createSlideMarkBackgroundPlayer();
  return {
    update(target, background) {
      return player.attach(target, daySkyBackground(background));
    },
    destroy() {
      player.unmount();
    },
  };
}

const manifest = YAML.parse(manifestSource) as ThemeDefinition;

export const skydiveTheme: ThemeDefinition = {
  ...manifest,
  animations: [
    {id: 'skydive:welcome-flight', factory: welcomeFlightFactory},
    {prefix: 'skydive:malfunction-', factory: malfunctionFactory},
  ],
  createBackground,
};
